import { useGetRequest } from 'hooks/utils/useGetRequest';
import { SettlementPayments } from 'interfaces/balances';
import { format } from 'date-fns';

function getPreviousMonth(date = new Date()) {
  const previous = new Date(date.getTime());
  previous.setMonth(date.getMonth() - 1);

  return previous;
}

const useGetSettlementPayments = (startDate?: string, endDate?: string) => {
  const defaultStartDate = `${format(getPreviousMonth(), 'yyyy-MM-dd')}`;
  const defaultEndDate = `${format(new Date(), 'yyyy-MM-dd')}`;
  const path = `v1/reports/payment?date_from=${startDate || defaultStartDate}T00:00:00Z&date_to=${endDate || defaultEndDate}T23:59:59Z`;

  const [{ data, error, loading }, execute] = useGetRequest<SettlementPayments>({
    path,
  });

  return {
    payments: data?.payments
			.map((payment)=>{
				payment.settlement_date = payment.settlement_date.substring(0,10);
				return payment;
			})
			.reduce((acc, payment)=> {
			acc.set(payment.settlement_date, payment.file)
			return acc
		}, new Map())?? new Map(),
    isLoadingSettlementPayments: loading,
    isError: error,
	execute: execute,
  };
};

export default useGetSettlementPayments;
